module.exports = __webpack_public_path__ + "img/newH.c2b7e016.png";